import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import { usePreferencesContext } from 'contexts/preferences';
import styles from './style.module.scss';
import { buildClassName } from 'utils/build-class-name';
import Button from 'components/control/button';
import EarthIcon from 'components/icon/earth-icon';
import { useIsMobile } from 'hooks/use-size-class';
import { LOCALE_SEARCH_PATHS, Namespaces } from 'types/locales';

export type SatelliteControlProps = {
  onViewToggle(): string | undefined;
  isHidden?: boolean;
  className?: string;
  extraRightMargin?: boolean;
  isAiSearch?: boolean;
};

const SatelliteControl = ({ onViewToggle, isHidden = false, className, extraRightMargin, isAiSearch }: SatelliteControlProps) => {
  const { t } = useTranslation(Namespaces.SEARCH);
  const [buttonLabel, setButtonLabel] = useState<string>(t(LOCALE_SEARCH_PATHS.MAP_SATELLITE, { defaultValue: 'Satellite' }));
  const { isMapSearchOpen } = usePreferencesContext();
  const isMobile = useIsMobile();

  const toggleSatelliteView = () => {
    const currentLabel = onViewToggle();
    if (currentLabel === mapkit.Map.MapTypes.Satellite) {
      setButtonLabel(t(LOCALE_SEARCH_PATHS.MAP_STREET, { defaultValue: 'Street' }));
    } else if (currentLabel === mapkit.Map.MapTypes.Standard) {
      setButtonLabel(t(LOCALE_SEARCH_PATHS.MAP_SATELLITE, { defaultValue: 'Satellite' }));
    }
  };

  return (
    <div className={buildClassName(styles.component, className, isHidden && styles['not-visible'], isMapSearchOpen && isMobile && styles['extra-top-margin'], extraRightMargin && styles['extra-right-margin'], isAiSearch && styles['ai-search'])}>
      <Button
        onClick={toggleSatelliteView}
        label={buttonLabel}
        theme={'secondary'}
        Icon={EarthIcon}
      />
    </div>
  );
};

export default SatelliteControl;
